import React from 'react';
import { FormGroup, Label, Input, FormFeedback, FormText } from 'reactstrap';

/*
 * Generic labeled select bound to a { value, valid, invalid, error } field.
 * `options` items provide { key, value, name }. Visibility conditions
 * (e.g. city/venue only for training camp) belong at the call site.
 */
const SelectField = ({
  label,
  field,
  options,
  placeholder,
  placeholderValue = 0,
  onChange,
  showHelp = false,
}) => {
  return (
    <FormGroup className="mb-2">
      <Label for={`FormGroup${label}`} className="text-gray font-weight-bold">
        {label}
      </Label>
      <Input
        type="select"
        valid={field.valid}
        invalid={field.invalid}
        value={field.value}
        onChange={({ target }) => onChange(target.value)}
      >
        <option value={placeholderValue} disabled hidden>
          {placeholder}
        </option>
        {options.map((item) => (
          <option key={item.key} value={item.value}>
            {item.name}
          </option>
        ))}
      </Input>
      {showHelp && <FormText>{field.help || 'Optional options'}</FormText>}
      <FormFeedback invalid="true">*{field.error}</FormFeedback>
    </FormGroup>
  );
};

export default SelectField;
